'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _helpers = require('../utils/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IntlProviderWrapper = function IntlProviderWrapper(Component) {
    return function (props) {
        return _react2.default.createElement(
            _reactIntl.IntlProvider,
            (0, _helpers.getLocaleAndMessages)(),
            _react2.default.createElement((0, _reactIntl.injectIntl)(Component), props)
        );
    };
};

exports.default = IntlProviderWrapper;